import type { TypedMyHotelFlowLine } from './-MyHotelFlowLine';
import RawMyHotelFlowLine from './MyHotelFlowLine.vue';
export * from './-MyHotelFlowLine';
export const MyHotelFlowLine = RawMyHotelFlowLine as typeof TypedMyHotelFlowLine;
